export const DATABASE_MODE_TYPE_ASI = 4;
const SIDEBAR_RECENT_ITEMS_FILTERS = new Set([
    'all',
    'sessions',
    'automations',
]);
export function isSidebarRecentItemsFilter(value) {
    return SIDEBAR_RECENT_ITEMS_FILTERS.has(value);
}
//# sourceMappingURL=recentItemsTypes.js.map